import type { PageData } from "../../api";
import { spaMetaHasRedisSnapshot } from "./spaMetaHasRedisSnapshot";
export function applySpaPagePayload(
  payload: PageData,
  expectedRouteId: string,
  setData: (p: PageData) => void,
  setError: (msg: string | null) => void
): PageData | null {
  const exp = String(expectedRouteId || "").trim();
  const pr = String(payload.route || "").trim();
  const meta =
    payload.meta && typeof payload.meta === "object" && !Array.isArray(payload.meta)
      ? (payload.meta as Record<string, unknown>)
      : {};
  if (exp === "redis_status") {
    if (spaMetaHasRedisSnapshot(meta)) {
      setError(null);
      const data = pr === exp ? payload : { ...payload, route: "redis_status", meta: { ...meta } };
      setData(data);
      return data;
    }
    setError(
      `Redis status was not included in the API response (missing meta.redis_status). ` +
        `Server said route=${pr || "?"} — open /api/spa/page-data?route=redis_status in the same browser session. ` +
        `Restart the backend if that JSON also lacks meta.redis_status.`
    );
    return null;
  }
  if (exp === "settings" && pr === exp) {
    const choices = meta.timezone_choices;
    if (!Array.isArray(choices) || choices.length === 0) {
      setError(
        `System settings response is missing meta.timezone_choices. Open /api/spa/page-data?route=settings in the same session, or restart the backend.`
      );
      return null;
    }
  }
  if (exp === "users" && pr === exp) {
    if (!Array.isArray(meta.users)) {
      setError(`Users list response is missing meta.users. Restart the backend or open /api/spa/page-data?route=users.`);
      return null;
    }
  }
  if (exp === "users_new" && pr === exp) {
    if (!Array.isArray(meta.page_permissions)) {
      setError(`Create user response is missing meta.page_permissions. Restart the backend or open /api/spa/page-data?route=users_new.`);
      return null;
    }
  }
  if (exp === "user_edit" && pr === exp) {
    if (meta.load_error && String(meta.load_error).trim()) {
      setError(null);
      setData(payload);
      return payload;
    }
    const eu = meta.edit_user;
    if (!eu || typeof eu !== "object" || Array.isArray(eu)) {
      setError(`Edit user response is missing meta.edit_user. Open /api/spa/page-data?route=user_edit&username=…`);
      return null;
    }
  }
  if (pr !== exp) {
    setError(
      `API route mismatch: this screen is "${exp}" but the server returned "${pr || "(empty)"}". ` +
        `Try /api/spa/page-data?route=${encodeURIComponent(exp)}`
    );
    return null;
  }
  setError(null);
  setData(payload);
  return payload;
}
